import { FC, useMemo } from 'react'
import { Form } from 'antd'
import { useGetMyShipmentsPeriodStatsQuery } from '../../../store/api/shipments-api'
import type { ShipmentPeriodStatsQueryParams } from '../../../types/api/shipment-period-stats'
import { ShipmentsPeriodStatsRow } from './shipments-period-stats-row'

const initialValues: ShipmentPeriodStatsQueryParams = {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
}

export const ShipmentsPeriodStatsBlock: FC = () => {
    const [form] = Form.useForm<ShipmentPeriodStatsQueryParams>()
    const month = Form.useWatch('month', form) ?? initialValues.month
    const year = Form.useWatch('year', form) ?? initialValues.year
    const client = Form.useWatch('client', form)
    const periodStatsArg = useMemo(
        (): ShipmentPeriodStatsQueryParams => ({
            month,
            year,
            ...(client ? { client } : {}),
        }),
        [month, year, client]
    )
    const periodStatsQuery = useGetMyShipmentsPeriodStatsQuery(periodStatsArg)

    return (
        <Form form={form} initialValues={initialValues} component={false}>
            <ShipmentsPeriodStatsRow
                stats={periodStatsQuery.data?.data}
                isFetching={periodStatsQuery.isFetching}
                isError={periodStatsQuery.isError}
            />
        </Form>
    )
}
